import React from 'react';
import './Checkbox.scss';

interface CheckboxProps {
    checked: boolean;
    style?: React.CSSProperties;
    onChange: (isChecked: boolean) => void;
    checkmarkColor?: string;
}

export const Checkbox: React.FunctionComponent<CheckboxProps> = ({
                                                                     checked,
                                                                     onChange,
                                                                     style,
                                                                     checkmarkColor = '#007ABE'
                                                                 }: CheckboxProps) => {
    const handleCheck = (e: React.MouseEvent) => {
        e.stopPropagation();
        onChange(!checked);
    };

    return (
        <div
            className='checkbox-element-container'
            onClick={handleCheck}
            style={{...style}}
        >
            <div
                className={`checkbox-element${checked ? ' checkbox-element--checked' : ''}`}>
                {checked && (
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        fill={checkmarkColor}
                        width='20px'
                        height='20px'
                    >
                        <path d='M0 0h24v24H0z' fill='none'/>
                        <path d='M9 16.2l-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4z'/>
                    </svg>
                )}
            </div>
        </div>
    );
}

export default Checkbox;